import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './table.scss';
import { GeckoTableHeaderRow, GeckoTableRow } from './';
import {
  GeckoTableCellsModel,
  GeckoPaginationModel,
  GeckoTableMassActionModel,
} from '../../models';

class GeckoTable extends Component {
  renderHeader() {
    if (!this.props.hideTableHeader) {
      return (
        <GeckoTableHeaderRow
          cols={this.props.cols}
          massAction={this.props.massAction}
          rows={this.props.rows}
          pagination={this.props.pagination}
        />
      );
    }
    return null;
  }

  renderRows() {
    return this.props.rows.map((row, i) => (
      <GeckoTableRow
        cols={this.props.cols}
        massAction={this.props.massAction}
        rowHandler={this.props.rowHandler}
        row={row}
        index={i}
        key={i}
      />
    ));
  }

  renderAlert = () => {
    return (
      <div class="gecko-alert alert alert-warning" role="alert" aria-live="off">
        <span>There are no results to show.</span>
      </div>
    );
  };

  render() {
    const hasData = this.props.rows && this.props.rows.length;
    return (
      <div className="gecko-table-wrapper">
        <table className="gecko-table table table-bordered">
          {hasData ? this.renderHeader() : null}
          <tbody>{this.renderRows()}</tbody>
        </table>
        {!hasData && this.renderAlert()}
      </div>
    );
  }
}

GeckoTable.defaultProps = {
  cols: [],
  rows: [],
  hideTableHeader: false,
  pagination: {},
};

GeckoTable.propTypes = {
  cols: GeckoTableCellsModel.isRequired,
  rows: PropTypes.array.isRequired,
  hideTableHeader: PropTypes.bool,
  pagination: PropTypes.shape(GeckoPaginationModel),
  massAction: GeckoTableMassActionModel,
};

export default GeckoTable;
